export const councillorQ1 =
    '1) Did you vote against the SFIS? Note: An answer is not required here as the meeting minutes provide this, but additional information is welcomed.';
export const councillorQ2 =
    '2) Have you read the CSIRO "Donnelly River Model Review" by Justin Hughes released 31/05/2021?';
export const councillorQ3 = '3) Do you oppose an SFIS style water scheme?';
export const councillorQ4 = '4) Do you oppose a water trading market in principle?';
